import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
//import store from './store'
import { store } from './redux/store'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import * as Sentry from '@sentry/react'

// Sentry (Roger task #176 iter 2, 13-jun-2026). Solo activo si DSN está set.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: 0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
  })
}

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// PWA Fase 1 (Roger 29-may-2026): registrar service worker para que la app sea
// instalable + cache de assets. Solo activo en producción (no localhost).
serviceWorkerRegistration.register()
